import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import paymentDetailAtom from '../atoms/paymentDetailAtom';

const PaymentSuccessful = () => {
  const navigate = useNavigate();
  const paymentDetail = useRecoilValue(paymentDetailAtom);

  return (
    <div className="min-h-screen bg-emerald-500 flex flex-col items-center relative">
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px) rotate(45deg); }
            50% { transform: translateY(-20px) rotate(45deg); }
            100% { transform: translateY(0px) rotate(45deg); }
          }

          @keyframes pulse {
            0% { transform: scale(1); opacity: 0.5; }
            50% { transform: scale(1.2); opacity: 0.8; }
            100% { transform: scale(1); opacity: 0.5; }
          }

          @keyframes dash {
            to {
              stroke-dashoffset: -100;
            }
          }

          .plane-path {
            stroke-dasharray: 10;
            animation: dash 20s linear infinite;
          }

          .star-pulse {
            animation: pulse 2s ease-in-out infinite;
          }

          .plane-float {
            animation: float 3s ease-in-out infinite;
          }
        `}
      </style>

   

      {/* Paper Plane Animation */}
      <div className="flex-1 flex flex-col items-center justify-center text-white -mt-20">
        {/* Paper Plane Icon with Path */}
        <div className="relative mb-8">
          {/* Curved Path */}
          <svg 
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32"
            viewBox="0 0 100 100"
            fill="none"
          >
            <path
              className="plane-path"
              d="M 10,50 Q 50,10 90,50"
              stroke="white"
              strokeWidth="2"
              strokeDasharray="4 4"
              strokeLinecap="round"
              opacity="0.3"
            />
          </svg>

          {/* Paper Plane */}
          <svg 
            className="w-16 h-16 text-white plane-float relative z-10"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2L2 22l20-10L12 2zm0 18l-3-6 3 2 3-2-3 6z"/>
          </svg>

          {/* Stars */}
          <div className="absolute -right-4 -top-4 text-white opacity-75 star-pulse" style={{animationDelay: '0s'}}>✦</div>
          <div className="absolute right-0 top-0 text-white opacity-50 star-pulse" style={{animationDelay: '0.5s'}}>✦</div>
          <div className="absolute -right-6 top-6 text-white opacity-25 star-pulse" style={{animationDelay: '1s'}}>○</div>
        </div>

        {/* Success Text */}
        <h1 className="text-2xl font-semibold mb-4 text-white animate-fade-in">
          Payment Successful
        </h1>

        {/* Transaction Details */}
        <p className="text-white/90 text-center text-sm max-w-xs mb-8 animate-fade-in-up">

           Funds transfer to "Roll & Charge" was successful.
          <br />
          {/* <span className="text-white/70 text-xs mt-2 block">
            Transaction Number - PPDH35587269YYTSG
          </span> */}
        </p>

        {/* Schedule Payment Button */}
        <button 
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-transparent border-2 border-white text-white rounded-full text-sm font-medium 
                     hover:bg-white/10 transition-all duration-300 transform hover:scale-105"
        >
          Back to Appointments
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessful; 